<template>
  <div class="site-footer">
    <div class="footer-container">
      <!-- 1. 选购及了解 -->
      <div class="footer-column">
        <div class="column-header">
          <p>{{ $t('footWindow.understand') }}</p>
        </div>
        <ul class="column-content">
          <li><a @click="goToLink('series-s')"><span>{{ $t('footWindow.seriesS') }}</span></a></li>
          <li><a @click="goToLink('support')"><span>{{ $t('footWindow.support') }}</span></a></li>
        </ul>
      </div>
      <div class="footer-column">
        <div class="column-header">
          <p>{{ $t('footWindow.about') }}</p>
        </div>
        <ul class="column-content">
          <li><a @click="goToLink('contact')">{{ $t('footWindow.contact') }}</a></li>
        </ul>
      </div>
    </div>

    <!-- 底部法律信息 -->
    <div class="footer-legal">
      <div class="legal-container">
        <p class="copyright">Copyright © 2025 江苏太势智能科技有限公司 保留所有权利。</p>
        <ul class="legal-links">
          <li><a>隐私政策</a></li>
          <li><a>使用条款</a></li>
          <li><a>销售政策</a></li>
          <li><a>法律信息</a></li>
          <li><a>网站地图</a></li>
        </ul>
        <p class="license">苏ICP备2025188257号-1</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppleStyleFooter',
  methods: {
    goToLink(path) {
      let path2 = this.$route.path;
      if (path2.startsWith('/zh')) {
        this.$router.push(`/zh/${path}`)
      }
      if (path2.startsWith('/en')) {
        this.$router.push(`/en/${path}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 页脚核心样式 */
.site-footer {
  background-color: #f5f5f8;
  color: #333;
  font-size: 12px;
  line-height: 1.6;
  padding: 20px;
}

/* 容器居中 + 列分布 - 左对齐 */
.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 20px 20px;
  gap: 80px;
  box-sizing: border-box;
}

/* 栏目头部 */
.column-header {
  width: 100%;
  padding: 5px 0;
}

.footer-column p {
  width: 100px;
  font-size: 14px;
  color: #1d1d1f;
  margin: 0 0 12px 0;
  text-transform: capitalize;
  text-align: left;
}

/* 栏目内容 */
.column-content {
  list-style: none;
  padding: 0;
  margin: 0 0 15px 0;
  text-align: left;
}

.footer-column li {
  margin-bottom: 8px;
  text-align: left;
}

.footer-column a {
  color: #888;
  text-decoration: none;
  transition: color 0.2s ease;
  cursor: pointer;
  display: inline-block;

  &:hover {
    color: #0071e3;
  }
}

/* 底部法律信息 */
.footer-legal {
  max-width: 1200px;
  margin: 10px auto 0;
  padding: 20px 20px 0;
  border-top: 1px solid #d2d2d7;
  box-sizing: border-box;
}

.legal-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  color: #888;
  font-size: 12px;
}

.legal-links {
  display: flex;
  gap: 16px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.legal-links a {
  color: #888;
  text-decoration: none;

  &:hover {
    color: #333;
  }
}

.copyright, .license {
  margin: 4px 0;
  text-align: left;
}

/* 手机端样式 */
@media (max-width: 768px) {
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    //align-items: center;
    gap: 20px;
    box-sizing: border-box;
    padding: 0 20px;
  }

  .footer-container > * {
    margin: 0;
  }

  /* 修改为适合居中的宽度，而不是100% */
  .footer-column {
    width: auto;
    min-width: 150px; /* 保持一定宽度避免过窄 */
  }

  .footer-column p {
    width: 100%;
    font-size: 14px;
    color: #1d1d1f;
    margin: 0 0 12px 0;
    text-transform: capitalize;
    text-align: center;
  }

  /* 手机端文字居中 */
  .column-content,
  .footer-column li {
    text-align: center;
    margin: 0 10px 12px 0;
  }

  .legal-container {
    flex-direction: column;
    align-items: center; /* 法律信息也居中 */
    gap: 12px;
    text-align: center; /* 文本居中 */
  }

  .copyright, .license {
    text-align: center; /* 版权信息居中 */
  }

  .legal-links {
    justify-content: center; /* 法律链接居中 */
    flex-wrap: wrap;
    gap: 12px 20px;
  }
}
</style>
